export const isJSON = (str: any): boolean => {
  if (typeof str === "object") {
    return str;
  }

  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
};

/**
 * Note frequenti da proporre per un fermo dell'impianto `plant`.
 *
 * `raw` è il valore di `HALTS_FREQUENTS_NOTES`, una stringa JSON in uno di due formati:
 * - un array: le stesse note per tutti gli impianti (il formato storico);
 * - un oggetto `{ "<impianto>": [...] }`: note diverse per impianto. Un impianto che non
 *   compare nell'oggetto non ha note.
 *
 * Qualunque valore non valido restituisce un elenco vuoto, che nasconde il box delle note.
 */
export const frequentNotesForPlant = <T>(raw: unknown, plant?: string | null): T[] => {
  let parsed: unknown = raw;
  if (typeof raw === "string") {
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return [];
    }
  }

  if (Array.isArray(parsed)) {
    return parsed as T[];
  }
  if (parsed && typeof parsed === "object" && plant) {
    const notes = (parsed as { [plantCode: string]: unknown })[plant];
    return Array.isArray(notes) ? (notes as T[]) : [];
  }
  return [];
};
